import { format } from 'date-fns';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSpace } from '../../../../hooks/useSpace';
import { useSpacePath } from '../../../../hooks/useSpacePath';
import { LocalStorageKeys } from '../../../../utils/localStorageKeys';
import { useIsOnboardingInProgress } from '../../../onboarding/hooks/useIsOnboardingInProgress';
import { useGetNextMeeting } from '../../api/useGetNextMeeting';

function hasAlreadyViewAlertToday(today: string) {
  const lastShownDate = localStorage.getItem(LocalStorageKeys.LastMeetingModalShown);
  return lastShownDate === today;
}

export function useMeetingWarning() {
  const { currentSpace } = useSpace();
  const spacePath = useSpacePath();
  const navigate = useNavigate();
  const today = React.useMemo(() => format(new Date(), 'yyyy-MM-dd'), []);
  
  const [isOpen, setIsOpen] = React.useState(false);
  const isOnboardingInProgress = useIsOnboardingInProgress();

  const { data: meeting, isSuccess } = useGetNextMeeting(currentSpace?.id);

  React.useEffect(() => {
    if (isSuccess && meeting && !hasAlreadyViewAlertToday(today)) {
      setIsOpen(true);
    }
  }, [isSuccess, meeting, today]);

  function handleClose() {
    setIsOpen(false);
    localStorage.setItem(LocalStorageKeys.LastMeetingModalShown, today);
  }

  function handleSeeMeetings() {
    handleClose();
    navigate(spacePath('/council/meetings'));
  }

  return {
    // Held back while the onboarding is due or open (also when replayed), rather than stacking two dialogs.
    isOpen: isOpen && !isOnboardingInProgress,
    handleSeeMeetings,
    meeting,
    handleClose,
  };
}
